module.exports = __webpack_public_path__ + "static/img/AiServices.370e505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/AiServices.png
// module id = JjAc
// module chunks = 1